// 新功能弹窗的忽略时间 测试环境是1分钟，正式环境是7天
export const ModalIgnoreTime =
  import.meta.env.VITE_ENV === 'production' || import.meta.env.VITE_ENV === 'preview'
    ? 7 * 24 * 60 * 60 * 1000
    : 1 * 24 * 60 * 60 * 1000;
